/**
 * Mirrors com.medprompt.identity.user.UserStatus
 */
export const UserStatus = Object.freeze({
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
});
